module.exports = __webpack_public_path__ + "static/img/cardnewbg.79d28909.png";